export const navs = [
  { name: 'Dashboard', rolesAllowed: ['admin', 'engineer', 'manager', 'quality', 'operations', 'maintenance'], path: '/dashboard' },
  { name: 'Commissioning Forms', rolesAllowed: ['admin', 'engineer', 'manager'], path: '/allforms/' },
  { name: 'Create SAT Forms', rolesAllowed: ['admin', 'manager', 'engineer'], path: '/formChecklist/' },
  { name: 'SAT Forms List', rolesAllowed: ['admin', 'engineer', 'manager', 'quality', 'operations', 'maintenance'], path: '/formList/' },
  { name: 'Contractor View', rolesAllowed: ['admin', 'manager', 'contractor'], path: '/contractorView/' },
  { name: 'User Management', rolesAllowed: ['admin', 'engineer', 'manager'], path: '/usermanagement' },
  { name: 'Site Assignment', rolesAllowed: ['admin'], path: '/assignment' },
];
